module.exports = __webpack_public_path__ + "img/airbase-stage_1.2.98848167.jpg";